<template>
  <aside
    class="nix-login-image"
    :style="{ backgroundImage: 'url(' + randomImage + ')' }"
    aria-hidden="true"
  />
</template>

<script>
export default {
  name: 'LoginImage',
  data() {
    return {
      images: [
        'https://conteudo.nixloc.com.br/wp-content/uploads/2026/01/capa_eventonoite.webp',
        'https://conteudo.nixloc.com.br/wp-content/uploads/2026/01/capa-doestoque.webp',
        'https://conteudo.nixloc.com.br/wp-content/uploads/2026/01/capa_assinatura.webp',
        'https://conteudo.nixloc.com.br/wp-content/uploads/2026/01/capa_dashboardpc.webp',
      ],
    }
  },
  computed: {
    randomImage() {
      const list = this.images
      return list[Math.floor(Math.random() * list.length)]
    },
  },
}
</script>

<style scoped>
.nix-login-image {
  flex: 1 1 62%;
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

@media (max-width: 900px) {
  .nix-login-image { display: none; }
}
</style>
